/**
 * New Trial JSON.
 * @module src/util/formJsons/surgery
 */
import { Form } from '../../components/Shared/FormEngine/FormEngine.types';

const formJson: Form = [
  {
    kind: 'field',
    name: 'topInfo',
    fieldLabel: 'All fields must be filled unless marked (Optional)', // TODO. Replace after localization
    fieldType: 'text',
    required: true,
    optionsAutoSelected: false,
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'franchise',
        fieldLabel: 'Franchise',
        fieldType: 'selectSingleDynamicPicker',
        required: true,
        optionsPlaceHolder: 'Franchise',
        optionsDynamic: 'getFranchises',
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'country',
        fieldLabel: 'Country',
        fieldType: 'selectSingleDynamicPicker',
        required: true,
        optionsPlaceHolder: 'Country',
        optionsDynamic: 'getCountries',
        optionsDependentField: ['franchise'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'account',
        fieldLabel: 'Account',
        fieldType: 'filterSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Account',
        optionsDynamic: 'getAccounts',
        optionsDependentField: ['franchise', 'country'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'eventName',
        fieldLabel: 'Event Name',
        fieldType: 'textArea',
        required: true,
        showTooltip: false,
        optionsAutoSelected: false,
        characterLimit: 55,
      },
      {
        kind: 'field',
        name: 'eventAddress',
        fieldLabel: 'Event Address',
        fieldType: 'textArea',
        required: true,
        showTooltip: false,
        optionsAutoSelected: false,
        characterLimit: 255,
      },
      {
        kind: 'field',
        name: 'organizedBy',
        fieldLabel: 'Organized By',
        fieldType: 'textArea',
        required: true,
        showTooltip: false,
        optionsAutoSelected: false,
        characterLimit: 55,
      },
      {
        kind: 'field',
        name: 'numberOfParticipants',
        fieldLabel: 'Number of Participants',
        fieldType: 'input',
        required: true,
        optionsAutoSelected: false,
        keypadType: 'number-pad',
        characterLimit: 2,
        showTooltip: false,
      },
    ],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'procedureType',
        fieldLabel: 'Procedure Type',
        fieldType: 'selectMultiDynamicPicker',
        required: true,
        optionsPlaceHolder: 'Procedure Type',
        optionsDynamic: 'getProcedureType',
        optionsDependentField: ['franchise'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'procedureDetails',
        fieldLabel: 'Procedure Details',
        fieldType: 'selectMultiDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Procedure Details',
        optionsDynamic: 'getProcedureDetails',
        optionsDependentField: ['franchise'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'navigation',
        fieldLabel: 'Navigation',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
      },
      {
        kind: 'field',
        name: 'robotics',
        fieldLabel: 'Robotics',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
      },
      {
        kind: 'field',
        name: 'revision',
        fieldLabel: 'Revision',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
      },
    ],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'salesRep',
        fieldLabel: 'Sales Rep',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Sales Rep',
        optionsDynamic: 'getSalesReps',
        optionsDependentField: ['franchise', 'country', 'account'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'coveringRep',
        fieldLabel: 'Covering Rep',
        fieldType: 'selectMultiDynamicPicker',
        required: false,
        optionsPlaceHolder: 'Covering Rep',
        optionsDynamic: 'getCoveringReps',
        optionsDependentField: ['franchise', 'country', 'account'],
        optionsAutoSelected: false,
      },
      {
        kind: 'field',
        name: 'startDate',
        fieldLabel: 'Start Date',
        fieldType: 'datePicker',
        required: true,
        optionsAutoSelected: false,
      },
      {
        kind: 'field',
        name: 'startTime',
        fieldLabel: 'Start Time',
        fieldType: 'timePicker',
        required: true,
        optionsAutoSelected: false,
      },
      {
        kind: 'field',
        name: 'endDate',
        fieldLabel: 'End Date',
        fieldType: 'datePicker',
        required: true,
        optionsAutoSelected: false,
      },
      {
        kind: 'field',
        name: 'endTime',
        fieldLabel: 'End Time',
        fieldType: 'timePicker',
        required: true,
        optionsAutoSelected: false,
      },
    ],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'shipTo',
        fieldLabel: 'Ship To',
        fieldType: 'selectSingleDynamicPicker',
        required: true,
        optionsPlaceHolder: 'Ship To',
        optionsDynamic: 'getShipToAddress',
        optionsDependentField: ['account'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'billTo',
        fieldLabel: 'Bill To',
        fieldType: 'selectSingleDynamicPicker',
        required: true,
        optionsPlaceHolder: 'Bill To',
        optionsDynamic: 'getBillToAddress',
        optionsDependentField: ['account'],
        optionsAutoSelected: true,
      },
      {
        kind: 'field',
        name: 'eventShippingLocation',
        fieldLabel: 'Event Shipping Location',
        fieldType: 'textArea',
        required: false,
        showTooltip: false,
        optionsAutoSelected: false,
        characterLimit: 255,
      },
      {
        kind: 'field',
        name: 'specialInstruction',
        fieldLabel: 'Shipping Instruction',
        fieldType: 'textArea',
        required: false,
        optionsPlaceHolder:
          'In addition to Shipping Instructions, You may enter onsite department, contact name, and phone number',
        showTooltip: true,
        optionsAutoSelected: false,
        characterLimit: 255,
      },
      {
        kind: 'field',
        name: 'deliveryService',
        fieldLabel: 'Delivery Service',
        fieldType: 'selectSingleDynamicPicker',
        required: true,
        optionsPlaceHolder: 'Delivery Service',
        optionsAutoSelected: false,
        optionsStatic: [
          {
            value: 'Next Day',
            label: 'Next Day',
            id: 'Next Day',
          },
          {
            value: 'Pre 9',
            label: 'Pre 9',
            id: 'Pre 9',
          },
          {
            value: 'Pre 10',
            label: 'Pre 10',
            id: 'Pre 10',
          },
          {
            value: 'Pre 12',
            label: 'Pre 12',
            id: 'Pre 12',
          },
          {
            value: 'Express',
            label: 'Express',
            id: 'Express',
          },
          {
            value: 'Local Courier',
            label: 'Local Courier',
            id: 'Local Courier',
          },
          {
            value: 'Warehouse Collection',
            label: 'Warehouse Collection',
            id: 'Warehouse Collection',
          },
        ],
      },
      {
        kind: 'field',
        name: 'customerPo',
        fieldLabel: 'Customer PO',
        fieldType: 'input',
        required: false,
        optionsPlaceHolder: 'Customer PO',
        optionsAutoSelected: false,
        characterLimit: 50,
      },
    ],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'comments',
        fieldLabel: 'Internal Comments',
        fieldType: 'textArea',
        required: false,
        optionsPlaceHolder:
          'Do not use to enter patient information, complaints, or set extension request.',
        showTooltip: true,
        optionsAutoSelected: false,
        characterLimit: 32000,
        permissionSets: ['show_csr_fields'],
      },
    ],
  },
];

/** Exporting newTrial json */
export default formJson;
